<script lang="ts">
  import { STORE } from "../../state.svelte";

  let totalTrades = $derived.by(() =>
    Object.values(STORE.bot.poolsStats).reduce(
      (acc, curr) => acc + curr.tradesRawCount,
      0,
    ),
  );

  let totalPools = $derived.by(() => Object.keys(STORE.bot.poolsStats).length);

  let totalWallets = $derived.by(() =>
    Object.keys(STORE.bot.poolsStats).reduce(
      (acc, curr) =>
        acc + Object.keys(STORE.bot.poolsStats[curr].wallets).length,
      0,
    ),
  );
</script>

<div class="flex flex-wrap gap-4">
  <div class="bg-gray-950/40 border border-gray-800/60 rounded-sm px-4 py-2 text-center">
    <p class="text-[9px] font-mono text-gray-600 uppercase tracking-widest mb-0.5">Trades</p>
    <p class="text-lg font-black text-white tabular-nums">{totalTrades.toLocaleString()}</p>
  </div>
  <div class="bg-gray-950/40 border border-gray-800/60 rounded-sm px-4 py-2 text-center">
    <p class="text-[9px] font-mono text-gray-600 uppercase tracking-widest mb-0.5">Pools</p>
    <p class="text-lg font-black text-white tabular-nums">{totalPools.toLocaleString()}</p>
  </div>
  <div class="bg-gray-950/40 border border-gray-800/60 rounded-sm px-4 py-2 text-center">
    <p class="text-[9px] font-mono text-gray-600 uppercase tracking-widest mb-0.5">Wallets</p>
    <p class="text-lg font-black text-white tabular-nums">{totalWallets.toLocaleString()}</p>
  </div>
</div>
